import { render, staticRenderFns } from "./AssetsLiabilitiesTable.vue?vue&type=template&id=6fc3e4f5"
import script from "./AssetsLiabilitiesTable.vue?vue&type=script&lang=js"
export * from "./AssetsLiabilitiesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports